module.exports = __webpack_public_path__ + "img/box_red.6e8f1ddb.png";